import { createFileRoute } from '@tanstack/react-router'
import CurriculumDetailPage from '@/pages/resources/curricula/detail'

export const Route = createFileRoute('/app/resources/curricula/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <CurriculumDetailPage id={Number(id)} />
}
